import _ from 'lodash';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { selectCampaignSelected, selectHinduTempleLocations } from '../../features/campaign.selectors';
import { CampaignService } from '../../services/campaign.service';
import { Subject } from 'rxjs';
import { Validators, UntypedFormGroup, UntypedFormControl, UntypedFormArray } from '@angular/forms';
import { filter, first, skipWhile, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-campaign-hindu-temple-puja-settings',
  templateUrl: './campaign-hindu-temple-puja-settings.component.html',
  styleUrls: ['./campaign-hindu-temple-puja-settings.component.scss']
})
export class CampaignHinduTemplePujaSettingsComponent implements OnInit, OnDestroy {
  public selectHinduTempleLocations$ = this.store.pipe(select(selectHinduTempleLocations));
  public timeZoneList = [
    { id: 1, label: 'Pacific Time (PST, UTC -7:00)', value: -25200 },
    { id: 2, label: 'Mountain Time (MT, UTC -6:00)', value: -21600 },
    { id: 3, label: 'Central Time  (CST,  UTC -4:00)', value: -14400 },
    { id: 4, label: 'Eastern Time  (EST, -3:00)', value: -10800 },
    { id: 5, label: 'Hawaii-Aleutian Standard Time(HAST, UTC -10)', value: -36000 }
  ]

  @Input() formGroupCampaignTypeData: UntypedFormGroup = null;
  public deityList: UntypedFormControl = null;

  public campaign$ = this.store.pipe(
    select(selectCampaignSelected)
  );
  
  public takeUntilSubject: Subject<any> = new Subject();
  
  constructor(
    public store: Store,
    public campaignService: CampaignService
  ) { }

  ngOnInit(): void {
    this.selectHinduTempleLocations$.pipe(
      skipWhile(list => list.length < 1),
      first(),
      takeUntil(this.takeUntilSubject)
    ).subscribe(list => {
      const campaignLocationId = this.formGroupCampaignTypeData.get('campaignLocationId');
      campaignLocationId.valueChanges.pipe(
        takeUntil(this.takeUntilSubject)
      ).subscribe(value => {
        const campaignLocation = _.find(list, { _id: value });
        this.formGroupCampaignTypeData.get('campaignLocation').setValue(campaignLocation);
      });
      if(_.isNull(campaignLocationId.value)) {
        const campaignLocation = list[0]
        this.formGroupCampaignTypeData.get('campaignLocationId').setValue(campaignLocation._id);
      }
    });

    this.campaign$.pipe(
      filter(campaign => campaign !== null),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      if(this.formGroupCampaignTypeData.get('timeZone').value === null) {
        this.formGroupCampaignTypeData.get('timeZone').setValue(this.timeZoneList[0].value);
      }
    });

    const sankalpDataDisplay = this.formGroupCampaignTypeData.get('sankalpDataDisplay');
    this.campaignService.configGroup(this.formGroupCampaignTypeData, sankalpDataDisplay, {
      name: 'sankalpDataNeeded',
      value: true
    }, [
      { name: 'nakshtraDisplay', defaultValue: '', validators: [Validators.required] },
      { name: 'gotraDisplay', defaultValue: '', validators: [Validators.required] },
      { name: 'rasiDisplay', defaultValue: '', validators: [Validators.required] }
    ], this.takeUntilSubject);

    this.deityList = this.formGroupCampaignTypeData.get('deityList') as UntypedFormControl;
    this.deityList.valueChanges.pipe(
      filter(list => _.get(list, 'length', 0) < 1),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      const options = this.formGroupCampaignTypeData.get('presetOptions') as UntypedFormArray;
      _.forEach(options.controls, option => {
        const deityRequired = option.get('deityRequired');
        deityRequired.setValue(false);
      })
    })
  }

  ngOnDestroy() {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

}
